import { Routes } from '@angular/router';
import { PTicketDetailComponent } from './components/pTicket/p-ticket-detail/p-ticket-detail.component';
import { PTicketListComponent } from './components/pTicket/p-ticket-list/p-ticket-list.component';
import { PTicketNewComponent } from './components/pTicket/p-ticket-new/p-ticket-new.component';
import { LoginComponent } from './components/generic/login/login.component';
import { RegisterUserComponent } from './components/generic/register-user/register-user.component';
import { AuthGuard } from './auth.guard';
import { ReportingMapComponent } from './components/reporting/reporting-map/reporting-map.component';
import { ReportingOverviewComponent } from './components/reporting/reporting-overview/reporting-overview.component';
import { ProfileComponent } from './components/profile/profile.component';
import { PanelComponent } from './components/administration/panel/panel.component';
import { SuperadminComponent } from './components/administration/superadmin/superadmin.component';
import { AdminGuard } from './admin.guard';

export const routes: Routes = [
    {path: "pTickets/list", component:PTicketListComponent, canActivate: [AuthGuard]},
    {path: "pTicket/new", component:PTicketNewComponent, canActivate: [AuthGuard]},
    {path: "pTicket/:id", component:PTicketDetailComponent, canActivate: [AuthGuard]},
    {path: "login", component:LoginComponent},
    {path: "register", component: RegisterUserComponent},
    {path: "reporting/map", component: ReportingMapComponent, canActivate: [AuthGuard]},
    {path: "reporting/overview", component: ReportingOverviewComponent, canActivate: [AuthGuard]},
    {path: "profile/overview", component: ProfileComponent, canActivate: [AuthGuard]},
    {path: "administration/panel", component: PanelComponent, canActivate: [AdminGuard]},
    {path: "administration/superadmin/panel", component: SuperadminComponent, canActivate: [AdminGuard]},
    // main entry point 
    {path: '', redirectTo: '/login', pathMatch : "full"},
];
